import tmhRequest from "@/config/tmhRequest";

export default {
  searchListStoreMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/storemenuitem/searchliststoremenuitem",
      method: "post",
      params: data
    });
  },
  searchListAllStoreMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/storemenuitem/searchlistallstoremenuitem",
      method: "post",
      params: data
    });
  },
  searchListNoPlusStoreMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/storemenuitem/searchlistnoplusstoremenuitem",
      method: "post",
      params: data
    });
  },
  addStoreMenuItem: function(data) {
    return tmhRequest({
      url: "/menu/tmh/storemenuitem/addstoremenuitem",
      method: "post",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/menu/storemenuitem.js